import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { range, sample } from 'lodash'

interface Props {
  messagesPerGroup: number
}

export const MessageListSkeleton = ({ messagesPerGroup }: Props) => {
  return (
    <Box component="ul" paddingTop="s12" gap="s32">
      {range(2).map((dateGroupKey) => (
        <Box
          key={`messages-date-group-${dateGroupKey}`}
          component="li"
          gap="s24"
          alignItems="center"
        >
          <Skeleton width="s140" height="s24" />
          <Box component="ul" gap="s32" width="full">
            {range(messagesPerGroup).map((groupItem) => (
              <Box
                key={`messages-group-${groupItem}`}
                width="full"
                component="li"
                gap="s8"
                style={{ maxWidth: '95%' }}
                alignSelf={groupItem % 3 === 1 ? 'flexStart' : 'flexEnd'}
                alignItems={groupItem % 3 === 1 ? 'flexStart' : 'flexEnd'}
              >
                <Skeleton
                  width={sample(['s600', 's400', 's360', 's600'])}
                  height={sample(['s48', 's40', 's32'])}
                />
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  )
}
